// src/plugins/posthog.js
import posthog from "posthog-js"

export default {
    install(Vue) {
        posthog.init("phc_QrkRyLvTofrtBZjJfwGe9NsIUY0weg0ymHUoXMClCZS", {
            api_host: "https://eu.i.posthog.com",
            defaults: "2025-11-30",
            disable_session_recording: true,
        })

        Vue.prototype.$posthog = posthog
    },
}
